__webpack_require__.p = "/mandor-portfolio/";